import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Moon, Flower } from 'lucide-react';
const features = [{
  title: 'Daily Balance Score',
  description: 'One number that shows the quality of your digital day. Are you creating or consuming? Connecting or scrolling? Not to judge—to help you notice.',
  icon: Activity
}, {
  title: 'Mindful Blocking',
  description: 'Set focus sessions for work, meditation, meals, or sleep. Your distracting apps fade away. Just you and what you chose to do.',
  icon: Moon
}, {
  title: 'Your Lotus Garden',
  description: 'Each moment of presence blooms a lotus in your pond. Not points or streaks—just quiet beauty that grows with your practice.',
  icon: Flower
}];
export function FeaturesSection() {
  return <section className="py-24 px-6 bg-pond-dark-lighter relative overflow-hidden" data-id="element-60">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-pond-blue/5 to-transparent pointer-events-none" data-id="element-61" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-62">
        <motion.div className="text-center mb-20" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-63">
          <h2 className="text-4xl md:text-6xl font-serif text-pond-cream mb-4" data-id="element-64">
            Three Things That Matter
          </h2>
          <p className="text-pond-cream-muted text-lg max-w-xl mx-auto" data-id="element-65">
            Simple tools designed with intention, not addiction.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-66">
          {features.map((feature, index) => <motion.div key={index} className="group relative p-8 rounded-3xl bg-pond-dark-card border border-pond-blue/10 hover:border-pond-blue/30 transition-all duration-500" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.6
        }} data-id="element-67">
              {/* Hover glow */}
              <div className="absolute inset-0 rounded-3xl bg-pond-blue/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-68" />

              <div className="relative z-10" data-id="element-69">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-pond-blue/20 to-pond-lavender/20 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500" data-id="element-70">
                  <feature.icon size={28} className="text-pond-blue" strokeWidth={1.5} data-id="element-71" />
                </div>

                <h3 className="text-2xl font-serif text-pond-cream mb-4" data-id="element-72">
                  {feature.title}
                </h3>
                <p className="text-pond-cream-muted leading-relaxed font-light" data-id="element-73">
                  {feature.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}